/* eslint-disable */
/* this file is generated by generateIcons script */

import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class CalendarIcon extends BaseIcon {
    getChildren = () => [
        <g id="Group_14337" data-name="Group 14337" transform="translate(0.5 0.5)">
            <path id="Path_22628" data-name="Path 22628" d="M.8,2.4H14.972V15H.8Z" transform="translate(-0.8 -0.825)" fill="none" stroke={this.getColor()} strokeLinecap="round" strokeLinejoin="round" strokeWidth="1"/>
            <path id="Path_22629" data-name="Path 22629" d="M4,.8V3.949" transform="translate(-0.851 -0.8)" fill="none" stroke={this.getColor()} strokeLinecap="round" strokeLinejoin="round" strokeWidth="1"/>
            <path id="Path_22630" data-name="Path 22630" d="M12,.8V3.949" transform="translate(-0.977 -0.8)" fill="none" stroke={this.getColor()} strokeLinecap="round" strokeLinejoin="round" strokeWidth="1"/>
            <path id="Path_22631" data-name="Path 22631" d="M.8,7.2H14.972" transform="translate(-0.8 -0.901)" fill="none" stroke={this.getColor()} strokeLinecap="round" strokeLinejoin="round" strokeWidth="1"/>
        </g>]
    getViewBox = () => '0 0 16 16'
}
